/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<g clipPath="url(#clip0_2004_10695)">
				<path
					opacity="0.4"
					d="M7.00002 12L4.53848 8L3.9231 7M7.00002 12L4.53848 16L3.9231 17M7.00002 12H11"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M3.92308 7L3.61538 6.5V6.5C2.87292 5.2935 2.50169 4.69025 2.4285 4.36508C2.12262 3.00607 3.26502 1.75843 4.64566 1.94368C4.976 1.988 5.60955 2.30477 6.87664 2.93832L19.2757 9.13784C21.1181 10.059 22.0393 10.5197 22.3349 11.143C22.5922 11.6854 22.5922 12.3146 22.3349 12.857C22.0393 13.4803 21.1181 13.941 19.2757 14.8622L6.87663 21.0617C5.60955 21.6952 4.976 22.012 4.64566 22.0563C3.26502 22.2416 2.12262 20.9939 2.4285 19.6349C2.50169 19.3098 2.87292 18.7065 3.61538 17.5V17.5L3.92308 17"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_10695">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<g clipPath="url(#clip0_2004_10698)">
				<path
					opacity="0.12"
					d="M19.2757 9.13784L9.03859 4.0193C6.04164 2.52082 4.54316 1.77158 3.76542 2.02258C3.09409 2.23924 2.58655 2.79354 2.42974 3.48131C2.24806 4.2781 3.12611 5.70492 4.8822 8.55857L5.96793 10.3229C6.34266 10.9318 6.53003 11.2363 6.60315 11.5622C6.66781 11.8505 6.66781 12.1495 6.60315 12.4378C6.53003 12.7637 6.34266 13.0682 5.96793 13.6771L4.8822 15.4414C3.12611 18.2951 2.24806 19.7219 2.42974 20.5187C2.58655 21.2065 3.09409 21.7608 3.76542 21.9774C4.54316 22.2284 6.04162 21.4792 9.03856 19.9807L9.03858 19.9807L19.2757 14.8622C21.1181 13.941 22.0393 13.4803 22.3349 12.857C22.5922 12.3146 22.5922 11.6854 22.3349 11.143C22.0393 10.5197 21.1181 10.059 19.2757 9.13784Z"
					fill="currentColor"
				/>
				<path
					d="M7 12L4.8822 15.4414C3.12611 18.2951 2.24806 19.7219 2.42974 20.5187C2.58655 21.2065 3.09409 21.7608 3.76542 21.9774C4.54316 22.2284 6.04163 21.4792 9.03858 19.9807L19.2757 14.8622C21.1181 13.941 22.0393 13.4803 22.3349 12.857C22.5922 12.3146 22.5922 11.6854 22.3349 11.143C22.0393 10.5197 21.1181 10.059 19.2757 9.13784L9.03859 4.0193C6.04164 2.52082 4.54316 1.77158 3.76542 2.02258C3.09409 2.23924 2.58655 2.79354 2.42974 3.48131C2.24806 4.2781 3.12611 5.70492 4.8822 8.55857L7 12ZM7 12H11"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_10698">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<g clipPath="url(#clip0_2004_10704)">
				<path
					d="M6.55192 11.25C6.22569 11.25 6.06257 11.25 5.91565 11.2036C5.78561 11.1626 5.66535 11.0954 5.56224 11.0061C5.44574 10.9053 5.36025 10.7664 5.18927 10.4886L4.33539 9.10099C2.14027 5.53393 1.04271 3.7504 1.2698 2.75441C1.46583 1.89469 2.10025 1.20182 2.93941 0.930999C3.91158 0.617244 5.78468 1.55379 9.53087 3.42689L19.5217 8.42228C21.8247 9.5738 22.9762 10.1496 23.3457 10.9287C23.6673 11.6067 23.6673 12.3933 23.3457 13.0713C22.9762 13.8504 21.8247 14.4262 19.5217 15.5777L9.53087 20.5731C5.78468 22.4462 3.91158 23.3827 2.93941 23.069C2.10025 22.7982 1.46583 22.1053 1.2698 21.2456C1.04271 20.2496 2.14027 18.466 4.33539 14.899L5.18926 13.5114C5.36024 13.2336 5.44573 13.0947 5.56223 12.9939C5.66533 12.9046 5.7856 12.8374 5.91563 12.7964C6.06256 12.75 6.22568 12.75 6.55191 12.75L11.25 12.75C11.6642 12.75 12 12.4142 12 12C12 11.5858 11.6642 11.25 11.25 11.25L6.55192 11.25Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_10704">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<g clipPath="url(#clip0_2004_10693)">
				<path
					d="M11 12H8.78814C8.13568 12 7.80944 12 7.51559 12.0928C7.25552 12.1748 7.01499 12.3092 6.80878 12.4877C6.57577 12.6894 6.40479 12.9672 6.06284 13.5229L4.8822 15.4414C3.12611 18.2951 2.24806 19.7219 2.42974 20.5187C2.58655 21.2065 3.09409 21.7608 3.76542 21.9774C4.54316 22.2284 6.04163 21.4792 9.03858 19.9807L19.2757 14.8622C21.1181 13.941 22.0393 13.4803 22.3349 12.857C22.5922 12.3146 22.5922 11.6854 22.3349 11.143C22.0393 10.5197 21.1181 10.059 19.2757 9.13784L9.03859 4.0193C6.04164 2.52082 4.54316 1.77158 3.76542 2.02258C3.09409 2.23924 2.58655 2.79354 2.42974 3.48131C2.24806 4.2781 3.12611 5.70493 4.8822 8.55858L5.15385 9L5.5 9.5625"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_10693">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<g clipPath="url(#clip0_2004_10691)">
				<path
					d="M7 12L4.8822 15.4414C3.12611 18.2951 2.24806 19.7219 2.42974 20.5187C2.58655 21.2065 3.09409 21.7608 3.76542 21.9774C4.54316 22.2284 6.04163 21.4792 9.03858 19.9807L19.2757 14.8622C21.1181 13.941 22.0393 13.4803 22.3349 12.857C22.5922 12.3146 22.5922 11.6854 22.3349 11.143C22.0393 10.5197 21.1181 10.059 19.2757 9.13784L9.03859 4.0193C6.04164 2.52082 4.54316 1.77158 3.76542 2.02258C3.09409 2.23924 2.58655 2.79354 2.42974 3.48131C2.24806 4.2781 3.12611 5.70492 4.8822 8.55857L7 12ZM7 12H11"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_10691">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<g clipPath="url(#clip0_2004_10701)">
				<path
					opacity="0.32"
					d="M5.49556 11.1694L4.18535 9.01215C2.03203 5.46669 0.95538 3.69396 1.18597 2.70141C1.38504 1.84454 2.01981 1.15535 2.85746 0.886635C3.82774 0.57537 5.68284 1.50292 9.39304 3.35802L19.5217 8.42234C21.8247 9.57386 22.9762 10.1496 23.3458 10.9287C23.6673 11.6067 23.6673 12.3933 23.3458 13.0714C22.9762 13.8505 21.8247 14.4262 19.5217 15.5778L19.5217 15.5778L9.39297 20.6421L9.39295 20.6421C5.68278 22.4972 3.8277 23.4248 2.85742 23.1135C2.01977 22.8448 1.385 22.1556 1.18593 21.2987C0.955336 20.3062 2.03198 18.5334 4.18527 14.988L5.49557 12.8306C5.67885 12.5288 5.77049 12.3779 5.80628 12.2166C5.83793 12.0739 5.83793 11.9261 5.80628 11.7834C5.77049 11.6221 5.67885 11.4712 5.49556 11.1694Z"
					fill="currentColor"
				/>
				<path
					d="M23.5869 12C23.587 12.3662 23.5066 12.7323 23.3458 13.0714C22.9762 13.8505 21.8247 14.4262 19.5218 15.5777L9.39299 20.6421C5.68282 22.4972 3.82771 23.4248 2.85743 23.1135C2.01978 22.8448 1.38501 22.1556 1.18594 21.2987C0.955347 20.3062 2.03199 18.5334 4.18528 14.988L5.49558 12.8306C5.67886 12.5288 5.7705 12.3779 5.80629 12.2166C5.82211 12.1453 5.83003 12.0726 5.83003 12H23.5869Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_10701">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
]);
